import { useLocation } from 'react-router';
import { PageHead } from '../components/PageHead';
import { EmptyState } from '../components/States';
import { NAV, navItemFor } from '../nav';

function crumbFor(path: string): string | undefined {
  if (path.startsWith('/configuracoes')) return 'Configurações';
  return (
    NAV.find((g) => g.items.some((i) => path.startsWith(i.to) && i.to !== '/'))?.label ?? undefined
  );
}

/** Placeholder for screens built in later milestones. */
export function ComingSoonPage() {
  const { pathname } = useLocation();
  const item = navItemFor(pathname);
  return (
    <>
      <PageHead crumb={crumbFor(pathname)} title={item?.label ?? 'Em breve'} />
      <section className="card">
        <EmptyState title="Em breve">
          Esta tela está no plano e chega numa das próximas etapas. Enquanto isso, o resto do
          sistema já funciona.
        </EmptyState>
      </section>
    </>
  );
}

export function NotFoundPage() {
  return (
    <section className="card">
      <EmptyState title="Página não encontrada">Confira o endereço ou use o menu.</EmptyState>
    </section>
  );
}
